export enum SessionSectionType {
  PACKAGE_INSTRUCTION = 'PACKAGE_INSTRUCTION',
  SECTION_INSTRUCTION = 'SECTION_INSTRUCTION',
  QUESTION = 'QUESTION',
  REVIEW_PRESCORE = 'REVIEW_PRESCORE',
  OVERVIEW = 'OVERVIEW',
}
